import React from 'react';
import { useSelector } from 'react-redux';
import { AiOutlineInfoCircle } from 'react-icons/ai';

const NotAuthed = () => {
  const currentRouteKey = useSelector?.((state) => state?.auth?.currentRouteKey) ?? '';
  const isCart = currentRouteKey?.includes('cart');
  
  return (
    <div className="flex items-center justify-center min-h-[250px] p-4">
      <div 
        style={{
          backgroundColor: "rgb(255 255 255 / 38%)"
        }}
        className="max-w-sm w-full backdrop-blur-sm rounded-lg p-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <AiOutlineInfoCircle className="h-4 w-4 text-slate-700" />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-slate-900 drop-shadow-sm">
              {isCart ? 'Unable to load cart' : 'This product is currently unavailable'}
            </h3>
            <p className="mt-1 text-sm text-slate-600 drop-shadow-sm">
              {isCart 
                ? 'Please refresh the page or try again later' 
                : 'Please try another product or check back later'
              }
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotAuthed
